export default function daysToEvent(dateEventString) {
  let dateEvent = new Date(dateEventString);
  let today = new Date();

  let diff = (today.getTime() - dateEvent.getTime()) / (24 * 60 * 60 * 1000);
  return Math.floor(diff);
  //return 12;
}
